// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-image{width:132px;height:132px;vertical-align:middle;text-align:center;margin-right:.5rem;border:1px solid gray;margin-bottom:1rem}.card-image img{margin-right:auto;margin-left:auto}.card-image .card-image-icon{margin:auto}.card-image-full-modal{width:90%;height:90%;max-width:100%}.card-image-full-modal img{max-width:90%;margin-right:auto;margin-left:auto}", ""]);
// Exports
module.exports = exports;
